import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "./CoreValues.css";

const CoreValues = () => {
  return (
    <section className="CoreValues">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="text-holder">
              <h2 className="heading">Our Core Values</h2>
            </div>

            <div className="main-container">
              <Swiper
                className="mySwiper"
                slidesPerView={3}
                breakpoints={{
                  320: {
                    slidesPerView: 1, // 1 slide on small screens (e.g., phones)
                    spaceBetween: 10,
                  },
                  410: {
                    slidesPerView: 1.5, // 1 slide on small screens (e.g., phones)
                    spaceBetween: 10,
                  },
                  500: {
                    slidesPerView: 2, // 2 slides on medium screens (e.g., tablets)
                    spaceBetween: 20,
                  },

                  992: {
                    slidesPerView: 3, // 2 slides on medium screens (e.g., tablets)
                    spaceBetween: 20,
                  },

                  1024: {
                    slidesPerView: 3, // 3 slides on larger screens (e.g., desktops)
                    spaceBetween: 30,
                  },

                  1199: {
                    slidesPerView: 3, // 3 slides on larger screens (e.g., desktops)
                    spaceBetween: 30,
                  },
                }}
              >
                <SwiperSlide>
                  <div className="card">
                    <div className="sidebar-div"></div>
                    <div className="img-main-holder">
                      <div className="img-holder">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/Assets/Images/AboutUs/CoreValues/img1.png"
                          }
                        />
                      </div>
                    </div>
                    <div className="text-holder">
                      <div className="">
                        <h3>Creativity</h3>
                      </div>
                      <div className="text-content">
                        <p>
                          We believe that great advertising starts with great
                          ideas. Our team is driven by creativity and
                          innovation, always seeking new ways to capture
                          attention & engage audiences.
                        </p>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  {" "}
                  <div className="card">
                    <div className="sidebar-div"></div>
                    <div className="img-main-holder">
                      <div className="img-holder">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/Assets/Images/AboutUs/CoreValues/img2.png"
                          }
                        />
                      </div>
                    </div>
                    <div className="text-holder">
                      <div className="">
                        <h3>Integrity</h3>
                      </div>
                      <div className="text-content">
                        <p>
                          Trust and transparency are at the heart of everything
                          we do. We are committed to building long-lasting
                          relationships with our clients through honest
                          communication and ethical practices.
                        </p>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
                <SwiperSlide>
                  {" "}
                  <div className="card">
                    <div className="sidebar-div"></div>
                    <div className="img-main-holder">
                      <div className="img-holder">
                        <img
                          src={
                            process.env.PUBLIC_URL +
                            "/Assets/Images/AboutUs/CoreValues/img3.png"
                          }
                        />
                      </div>
                    </div>
                    <div className="text-holder">
                      <div className="">
                        <h3>Excellence</h3>
                      </div>
                      <div className="text-content">
                        <p>
                          We strive for excellence in every campaign we create,
                          ensuring that your advertising is not only effective
                          but also memorable.
                        </p>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CoreValues;
